const state ={
  schemes: [],
accrualDefinitionData: {
    channelCode: [],
    divisionCode: "",
    productType: [],
    productCategory: [],
  },
  createAccrualFormData:{
    accrualId: undefined,
    accrualForm: {},
  },
  accrualList:{},
}
export default state;